import { getFormattedStoreName } from '@/helpers';
import { Store } from '@/types';
import { FilterDef } from '@alpine-iq/ui-library';

export function generateFilterDefs(retailStores: Store[]): FilterDef[] {
	return [
		{
			label: 'Locations',
			type: 'select-many',
			key: 'locations',
			options:
				retailStores?.map((store) => ({
					label: getFormattedStoreName(store),
					value: `${store.id ?? ''}`,
				})) ?? [],
		},
		{ label: 'Start Date', type: 'date-range', keyDateStart: 'dateRangeStart', keyDateEnd: 'dateRangeEnd' },
		{ label: 'Archived', type: 'toggle', key: 'archived' },
	];
}

export function downloadCSV(fileName: string, headers: Array<{ label: string; key: string }>, data: any[]) {
	// First row: header labels
	const headerRow = headers
		.map((header) => {
			const label = String(header.label);
			if (label.includes(',') || label.includes('"') || label.includes('\n')) {
				return `"${label.replace(/"/g, '""')}"`;
			}
			return label;
		})
		.join(',');

	// Data rows
	const dataRows = data
		.map((row) => {
			return headers
				.map((header) => {
					const value = row[header.key];
					if (value === null || value === undefined) return '';
					const stringValue = String(value);
					if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
						return `"${stringValue.replace(/"/g, '""')}"`;
					}
					return stringValue;
				})
				.join(',');
		})
		.join('\n');

	const csvContent = `${headerRow}\n${dataRows}`;

	// Create and download the file
	const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
	const link = document.createElement('a');
	const url = URL.createObjectURL(blob);
	link.setAttribute('href', url);
	link.setAttribute('download', fileName || 'persona_search_results.csv');
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	URL.revokeObjectURL(url);
}
